// Birthday block shown in the Our Game section. Update monthly:
// set the month, the names celebrating, and the party date.
// Leave `names` empty and the whole Birthdays block stays hidden.
// Emoji are real Unicode characters — swap any of them freely.
export const BIRTHDAYS = {
  note: "We celebrate birthdays once a month for everyone with a birthday that month. 🎂",
  month: "October",
  // Sorted by date, earliest first; use "TBD" when a date is unknown.
  names: [
    { name: "Jose Cruz", date: "October 10" },
  ],
  party: "",
  emoji: {
    heading: ["🎂", "🎉"], // shown on either side of the section heading
    pill: "⛳", // prefix on each name pill
    party: "🍾", // shown on either side of the party date
  },
};
